import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { Container } from '@nfs-react/components';

import { useText } from 'hooks';
import { Button } from 'helpers/components';
import { MOBILE, TABLET, DESKTOP } from 'helpers/styles/media';

const Article = ({ handleScroll }) => {
  return (
    <ArticleSection>
      <Container>
        <ArticleText>{useText('article__text', true)}</ArticleText>
      </Container>
      <ArticleButtonContainer>
        <ArticleButton>
          <Button buttonCss={buttonCss} clickHandler={handleScroll}>
            {useText('article__btn', true)}
          </Button>
        </ArticleButton>
      </ArticleButtonContainer>
    </ArticleSection>
  );
};

const ArticleSection = styled.section`
  @media ${DESKTOP} {
    padding-top: 90px;
  }

  @media ${TABLET} {
    padding-top: 25px;
  }

  @media ${MOBILE} {
    padding-top: 22px;
  }
`;

const ArticleText = styled.div`
  font-size: 18px;
  line-height: 185.6%;
  text-align: right;
  letter-spacing: -0.01em;
  color: #000000;
  max-width: 730px;
  margin-bottom: 60px;

  @media ${TABLET} {
    margin-bottom: 285px;
    letter-spacing: -0.02em;
  }

  @media ${MOBILE} {
    line-height: 174.8%;
    margin-bottom: 254px;
    letter-spacing: 0;
    max-width: 320px;
  }
`;

const ArticleButtonContainer = styled(Container)`
  @media ${MOBILE} {
    max-width: 100%;
    padding: 0;
  }
`;

const ArticleButton = styled.div`
  position: relative;
  border-radius: 80px 80px 0 0;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-image: ${({ theme: { imgUrl } }) => imgUrl('article-bg.jpg')};

  @media ${DESKTOP} {
    padding: 91px 0;
  }

  @media ${TABLET} {
    padding: 112px 0 70px;
  }

  @media ${MOBILE} {
    padding: 103px 0 48px;
    border-radius: 30px 30px 0 0;
  }

  &:before {
    content: '';
    display: block;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: ${({ theme: { imgUrl } }) => imgUrl('article.png')};
    width: 499px;
    height: 420px;
    position: absolute;
    top: -347px;
    left: -34px;

    @media ${TABLET} {
      top: -252px;
      left: calc(50% - 210px);
      width: 420px;
      height: 353px;
    }

    @media ${MOBILE} {
      width: 348px;
      height: 308px;
      top: -224px;
      left: calc(50% - 174px);
    }
  }
`;

const buttonCss = css`
  width: 100%;
  max-width: 452px;
  min-height: 73px;
  background: linear-gradient(
    0deg,
    #ac7524 3.88%,
    #c18d2f 11.96%,
    #f8cb49 28.97%,
    #ffd34d 31.1%,
    #fee565 58.42%,
    #fded6f 68.35%,
    #e38700 99.88%
  );
  box-shadow: 0 4px 9px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: #191104;
  margin: 0 auto;

  @media ${TABLET} {
    &:active {
      transform: scale(1.06);
    }
  }

  @media ${MOBILE} {
    max-width: 336px;

    &:active {
      transform: scale(1.06);
    }
  }
`;

Article.propTypes = {
  handleScroll: PropTypes.func.isRequired,
};

export default Article;
